import fetch from 'node-fetch'; // Ensure you have node-fetch installed

// Cache the promise to avoid fetching headers multiple times
let headersPromise = null;
const slack_id = 'UEM2ZS03S';

const test_slack_channel =
  'https://hooks.slack.com/services/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';
const error_slack_channel =
  'https://hooks.slack.com/services/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';
const slack_ids = {
  Biagio: 'U06HYU3G8KD',
  Rohan: 'UEM2ZS03S',
  Jacqui: 'UEPBUD2D8'
};
const all_team = ['Rohan', 'Biagio'];
const me_team = ['Biagio'];
const meta_team = ['Rohan', 'Jacqui', 'Biagio'];

async function checkResponse(
  response,
  apiType,
  apiEndpoint,
  payload,
  callPoint = ''
) {
  if (!response.ok) {
    const clonedResponse = response.clone();
    const errorCheck = await clonedResponse.json();

    console.error(
      `ERROR: API lnp-orderhandling-app call ${apiType} failed at endpoint ${apiEndpoint} during ${callPoint}. 
      Status: ${response.status} ${response.statusText || ''}.
      Payload: ${JSON.stringify(payload)}.`
    );
    const slackMessage = `
      API Error lnp-orderhandling-app encountered ${apiType} ${apiEndpoint} during ${callPoint}.\n
      Status: ${response.status} ${response.statusText || ''}.\n
      Payload: ${JSON.stringify(payload)}.\n
      Error: ${errorCheck.error || ''}.`;
    await postToSlackTeam(slackMessage, all_team, error_slack_channel);
  }
}

async function postToSlackTeam(
  slackMessage,
  slackTeams = all_team,
  slackChannel = error_slack_channel
) {
  let valuesInOrder = [];
  for (const key of slackTeams) {
    if (key in slack_ids) {
      valuesInOrder.push(`<@${slack_ids[key]}>`);
    }
  }

  const prefix = valuesInOrder.join('') + ': ';
  const fullMessage = prefix + slackMessage;
  const slackData = { text: fullMessage };

  try {
    const response = await fetch(slackChannel, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(slackData)
    });

    if (!response.ok) {
      throw new Error(
        `Request to Slack returned an error ${
          response.status
        }, the response is:\n${await response.text()}`
      );
    }
  } catch (error) {
    console.error('Error posting to Slack:', error.message);
  }
}

async function fetchHeaders() {
  const proxyUrl = 'https://lnp-cors.herokuapp.com/';
  const serviceUrl =
    'https://lnp-credentials.herokuapp.com/credentials?service=learnworlds';
  const url = `${proxyUrl}${serviceUrl}`;
  const requestHeaders = {
    Authorization: `Bearer -7224043605275900951`
  };

  try {
    const response = await fetch(url, { headers: requestHeaders });
    const data = await response.json();

    if (data.error) {
      // Log the error to the console and Slack
      console.error('Error fetching LearnWorlds headers:', data.error);
      await postToSlackCreds(
        `<@${slack_id}>There has been an error while fetching LearnWorlds credentials by agreements-app!\n${JSON.stringify(
          data
        )}`
      );
    } else {
      console.log(
        'LearnWorlds credentials successfully retrieved by agreements-app!'
      );
      await postToSlackCreds(
        `<@${slack_id}>LearnWorlds credentials successfully retrieved by agreements-app!`
      );
      // Return the fetched headers
      return {
        'Lw-Client': data.client_id,
        Authorization: `Bearer ${data.access_token}`
      };
    }
  } catch (error) {
    console.error('Failed to fetch LearnWorlds credentials:', error);
    await postToSlackCreds(
      `<@${slack_id}>Failed to fetch LearnWorlds credentials by scormify!\n${error}`
    );
  }

  // Fallback to default headers from config if there's an error or if the data contains an error
  return {
    Authorization: 'Bearer 6gUebWjJuibpA1JylHSsAK6s6TnWSLtEmWGeYLMk',
    'Lw-Client': '5f775cf55653e1402868c732'
  };
}

function getLearnworldsHeaders() {
  // Initialize headersPromise if it hasn't been already
  if (!headersPromise) {
    headersPromise = fetchHeaders();
  }
  return headersPromise;
}

async function postToSlackCreds(slackMessage) {
  const proxyUrl = 'https://lnp-cors.herokuapp.com/';
  const slackWebhookUrl =
    'https://hooks.slack.com/services/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';
  const slackData = { text: slackMessage };

  try {
    const response = await fetch(proxyUrl + slackWebhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(slackData)
    });

    if (!response.ok) {
      throw new Error(
        `Request to Slack returned an error ${
          response.status
        }, the response is:\n${await response.text()}`
      );
    }
  } catch (error) {
    console.error('Error posting to Slack:', error.message);
  }
}

function cleanUserInput(str) {
  if (str === null || str === undefined) {
    return null;
  }
  const repString = str.replace(/\//g, '_');
  const strippedString = repString
    .replace(/&/g, '')
    .replace(/"/g, '')
    .replace(/'/g, '')
    .replace(/;/g, '')
    .replace(/,/g, '')
    .replace(/~/g, '')
    .replace(/[\\:*?"<>|]/g, '')
    .trim();
  if (strippedString === '' || strippedString === undefined) {
    return null;
  }
  return strippedString;
}

export { getLearnworldsHeaders, cleanUserInput, checkResponse };
